import useDirtyChecker from "../../../hooks/useDirtyChecker";
import { useState } from "react";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import ReactComponentProps from "./ReactComponentProps";
import CodeEditor from "../../../components/BuilderComponents/CodeEditor/CodeEditor";

const ReactComponentEditor = ({ file, templateData, setTemplateData }) => {
  const { isDirty, markClean } = useDirtyChecker(templateData);
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = (key, value) => {
    setTemplateData((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSaveTemplate = async () => {
    try {
      setIsSaving(true);
      const payload = { ...templateData, name: file?.name };
      const response = await axiosInstance.patch(`/custom-component/${file.id}`, payload);
      toastSuccess(response.message);
      markClean();
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="d_flex flex_column">
      <GenericActionBar
        path={
          <div>
            <em>React Components</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSaveTemplate
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />

      <div className="template_form_outer builder_form">
        <ReactComponentProps onAdd={(props) => handleChange("props", props)} propsList={templateData.props || []} />

        <CodeEditor
          handleChange={(value) => handleChange("component", value)}
          value={templateData.component}
          enableBacktickTrigger={false}
        />
      </div>
    </div>
  );
};

export default ReactComponentEditor;
